import { mainSiteUrl } from '@/mocks/categories';

const benefits = [
  { feature: 'Verified Listings', benefit: 'Reduce scam risk', icon: 'ri-shield-check-line' },
  { feature: 'Price Comparison', benefit: 'Save up to 70% cost', icon: 'ri-scales-3-line' },
  { feature: 'Supplier Data', benefit: 'Faster decision making', icon: 'ri-database-2-line' },
  { feature: 'Auto-structured Sheets', benefit: 'Easy to use', icon: 'ri-file-excel-2-line' },
  { feature: 'Updated Database', benefit: 'Always fresh products', icon: 'ri-refresh-line' },
];

const comparison = [
  { platform: 'itaobuyspreadsheet', speed: '⭐⭐⭐⭐⭐', risk: 'Low', cost: 'High', ease: 'Very Easy', highlight: true },
  { platform: 'Manual Taobao Search', speed: '⭐⭐', risk: 'High', cost: 'Medium', ease: 'Hard', highlight: false },
  { platform: '1688 Direct Buying', speed: '⭐⭐⭐', risk: 'Medium', cost: 'High', ease: 'Complex', highlight: false },
  { platform: 'Traditional Agents', speed: '⭐⭐⭐', risk: 'Medium', cost: 'Medium', ease: 'Medium', highlight: false },
];

export default function ComparisonSection() {
  return (
    <section className="w-full flex flex-col lg:flex-row" id="comparison">
      <div className="w-full lg:w-1/2 relative overflow-hidden min-h-[360px] lg:min-h-[600px] bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20leather%20bags%20sunglasses%20and%20silk%20scarves%20arranged%20on%20light%20gray%20textured%20concrete%20with%20geometric%20composition%20pattern%20editorial%20product%20photography%20bright%20daylight%20sharp%20details%20commercial%20catalog%20style&width=960&height=1200&seq=comparison-left-v4&orientation=portrait"
          alt="itaobuyspreadsheet product comparison - diverse fashion items"
          title="itaobuyspreadsheet - Product Comparison"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute top-8 left-8">
          <p className="text-xs tracking-[0.2em] uppercase text-foreground-700 font-medium bg-background-50/80 px-3 py-1.5 rounded-full backdrop-blur-sm">
            / Comparison
          </p>
        </div>
        <div className="absolute bottom-8 left-8">
          <p className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-[1.05]">
            itaobuy<br />vs Others
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 px-4 md:px-10 py-12 md:py-20 flex flex-col justify-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
          Why Choose Itaobuyspreadsheet?
        </h2>

        <div className="mt-6 grid grid-cols-1 gap-3">
          {benefits.map((b) => (
            <div key={b.feature} className="flex items-center gap-4 p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className={`${b.icon} text-lg text-accent-600`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{b.feature}</p>
                <p className="text-xs text-foreground-500">{b.benefit}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <h3 className="text-sm font-semibold text-foreground-800 mb-3">Competitive Analysis</h3>
          <div className="overflow-x-auto -mx-2 px-2">
            <table className="w-full text-xs md:text-sm">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-2.5 pr-3 font-medium text-foreground-600">Platform</th>
                  <th className="text-center py-2.5 px-2 font-medium text-foreground-600">Speed</th>
                  <th className="text-center py-2.5 px-2 font-medium text-foreground-600">Risk</th>
                  <th className="text-center py-2.5 px-2 font-medium text-foreground-600">Cost Efficiency</th>
                  <th className="text-center py-2.5 pl-2 font-medium text-foreground-600">Ease</th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((row) => (
                  <tr
                    key={row.platform}
                    className={`border-b border-background-100 ${row.highlight ? 'bg-accent-50/60' : ''}`}
                  >
                    <td className="py-2.5 pr-3 font-medium text-foreground-800 whitespace-nowrap">{row.platform}</td>
                    <td className="py-2.5 px-2 text-center whitespace-nowrap text-foreground-600">{row.speed}</td>
                    <td className="py-2.5 px-2 text-center whitespace-nowrap text-foreground-600">{row.risk}</td>
                    <td className="py-2.5 px-2 text-center whitespace-nowrap text-foreground-600">{row.cost}</td>
                    <td className="py-2.5 pl-2 text-center whitespace-nowrap text-foreground-600">{row.ease}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
            Unlike traditional sourcing methods, <strong className="text-foreground-800">itaobuyspreadsheet</strong> removes complexity and centralizes verified product data into one optimized system.
          </p>
        </div>

        <div className="mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Access Itaobuy Sheet Now
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}